import { Json } from '@/integrations/supabase/types';

export interface ImageItem {
  url: string;
  order: number;
}

/**
 * Convert Json from database to ImageItem array
 */
export const jsonToImageArray = (json: Json | null | undefined): ImageItem[] => {
  if (!json) return [];
  if (Array.isArray(json)) {
    return json.map((item: any) => ({
      url: item.url || '',
      order: item.order || 0,
    }));
  }
  // Handle legacy string format
  if (typeof json === 'string' && json !== '') {
    return [{ url: json, order: 0 }];
  }
  return [];
};

/**
 * Convert ImageItem array to Json for database
 */
export const imageArrayToJson = (images: ImageItem[]): Json => {
  return JSON.parse(JSON.stringify(images || []));
};
